import { render, staticRenderFns } from "./jobfairUser.vue?vue&type=template&id=eb06ac68&scoped=true"
import script from "./jobfairUser.vue?vue&type=script&lang=js"
export * from "./jobfairUser.vue?vue&type=script&lang=js"
import style0 from "./jobfairUser.vue?vue&type=style&index=0&id=eb06ac68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb06ac68",
  null
  
)

export default component.exports